/**
 * Template CSV para importação de alunos.
 */

export const TEMPLATE_HEADERS_PT = [
    'Nome',
    'Email',
    'Tipo',
    'Status',
    'CPF',
    'Identidade',
    'Telefone',
    'CEP',
    'Endereço',
    'Número',
    'Complemento',
    'Bairro',
    'Cidade',
    'Estado',
    'País',
];

/** Chaves alinhadas ao formulário de usuário / payload da API */
export const TEMPLATE_HEADERS_KEY = [
    'name',
    'email',
    'type',
    'status',
    'socialNumber',
    'idNumber',
    'phone',
    'postcode',
    'address',
    'addressNumber',
    'addressComplement',
    'neighborhood',
    'city',
    'county',
    'country',
];

export const TEMPLATE_EXAMPLE_ROWS = [
    [
        'João da Silva',
        'joao.silva@email.com',
        '3',
        '1',
        '123.456.789-00',
        'MG1234567',
        '(11) 99999-9999',
        '01310-100',
        'Rua Exemplo',
        '100',
        'Apto 12',
        'Bela Vista',
        'São Paulo',
        'SP',
        'br',
    ],
    [
        'Maria Souza',
        'maria.souza@email.com',
        '3',
        '1',
        '987.654.321-00',
        'RJ7654321',
        '(21) 98888-7777',
        '20040-020',
        'Av. Central',
        '50',
        'Sala 3',
        'Centro',
        'Rio de Janeiro',
        'RJ',
        'br',
    ],
];

function escapeCsvCell(value) {
    const text = String(value ?? '');
    if (/[",\n\r]/.test(text)) {
        return `"${text.replace(/"/g, '""')}"`;
    }
    return text;
}

export function buildStudentImportCsv(headerLabels = TEMPLATE_HEADERS_PT) {
    const lines = [
        headerLabels.join(','),
        TEMPLATE_HEADERS_KEY.join(','),
        ...TEMPLATE_EXAMPLE_ROWS.map((row) =>
            row.map(escapeCsvCell).join(','),
        ),
    ];
    return `\uFEFF${lines.join('\n')}`;
}
